import ActiveFilter from "./ActiveFilter";

export default function(eventName, ajaxUrl) {
    const self = this;

    self.eventName = eventName;

    self.ajaxUrl = ajaxUrl;

    self.activeFilters = [];

    self.headers = {};

    self.init = () => {

        if('' !== window.location.search) {
            this.initFromQuery();
        }
        this.filter();

        let location = MrMovie.geolocation.getLocationFromSession();
        if(location) {
            self.setHeader('latitude', location.latitude);
            self.setHeader('longitude', location.longitude);
        }

    };

    self.initFromQuery = () => {
        let urlParams = new URLSearchParams(window.location.search);
        for(let urlParam of urlParams.entries()) {
            self.addFilters(urlParam[0], urlParam[1].split(","));

            if(urlParam[0] === 'longitude' || urlParam[0] === 'latitude') {
                if (typeof URLSearchParams !== 'undefined') {
                    history.replaceState(
                        null, '', location.pathname + location.search.replace(/[\?&]longitude=[^&]+/, '').replace(/[\?&]latitude=[^&]+/, '').replace(/^&/, '?')
                    );
                }
            }
        }
    };



    self.router = () => {
        return window.VueApp.$router;
    };

    self.getFilters = (id = null) => {
        if(null !== id) {
            return this.getActiveFilterById(id)
        } else {
            return this.getActiveFilters();
        }

    };

    self.setFilters = (id, values) => {
        this.setActiveFilters(id, values);
        self.updateQueryParams();
    };

    self.addFilters = (id, values) => {
        let filterItem = this.getActiveFilterById(id);

        if(typeof filterItem === 'undefined') {
            filterItem = new ActiveFilter(id, values);
            self.activeFilters.push(filterItem);
        } else {
            let key = this.getActiveFilterKeyById(id);
            self.activeFilters[key].addValues(values);
        }
    };

    self.getHeaders = () => {
        return this.headers;
    };

    self.getHeader = (id, defaultValue = '') => {
        let result = defaultValue;
        if(typeof this.headers[id] !== 'undefined') {
            result = this.headers[id];
        }
        return result;
    };

    self.setHeader = (id, value) => {
        this.headers[id] = value;
    };

    self.removeHeader = (id) => {
        delete this.headers[id];
    };

    self.removeFilters = (id = '', values = []) => {
        if('' === id) {
            let day = this.activeFilters[this.getActiveFilterKeyById('day')];
            let orderBy = this.activeFilters[this.getActiveFilterKeyById('order_by')];
            self.activeFilters = [];

            if(typeof day !== 'undefined' && typeof day.values !== 'undefined') {
                this.addFilters('day', day.values);
            }

            if(typeof orderBy !== 'undefined' && typeof orderBy.values !== 'undefined') {
                this.addFilters('orderBy', orderBy.values);
            }

            return;
        }

        let key = this.getActiveFilterKeyById(id);


        if(key && !values.length) {
            self.activeFilters.splice(key, 1);
            return;
        }

        if(key) {

            for (let value of values) {
                self.activeFilters[key].removeValue(value);
            }

            if(0 === self.activeFilters[key].getValues().length) {
                self.activeFilters.splice(key, 1);
            }

        }


    };

    self.filter = () => {
        self.getContent();
    };

    self.updateQueryParams = () => {
        self.router().push({path: self.router().currentRoute.path, query: self.getQueryParams()});
        self.setInLocalStorage();
        // temporary bugfix at home page
        if (window.location.pathname === '/') {
            window.location.reload(); //TODO: REMOVE THIS LINE! This is a temporary fix for the trailer bug
        }
    };

    self.getContent = () => {
        VueEvents.$emit('filters_locked', true);
        VueEvents.$emit('loading_items', true);

        let args = {};
        for(let activeFilter of self.activeFilters) {
            args[activeFilter.id] = activeFilter.values.join(',');
        }


        let promise = self.doRequest(args);

        promise.then(response => {
            if(typeof response.movies !== 'undefined') {
                VueEvents.$emit('loaded_movies', response.movies);
            }
            if(typeof response.cinemas !== 'undefined') {
                VueEvents.$emit('loaded_cinemas', response.cinemas);
            }
            if(typeof response.filters !== 'undefined') {
                VueEvents.$emit('loaded_filters', response.filters);
            }
            VueEvents.$emit('filters_locked', false);


        }, self);
    };

    self.doRequest = (data) => {

        let promise = $.ajax({
            url: self.ajaxUrl,
            headers: this.getHeaders(),
            data: data
        });
        self.lock = true;

        promise.then(response => {
            self.lock = false;
        }, self);

        return promise;
    };

    /**
     *
     * @param id
     * @param values
     * @returns {*}
     */
    self.setActiveFilters = (id, values) => {


        if(!values.length) {
            let key = this.getActiveFilterKeyById(id);
            self.activeFilters.splice(key, 1);
            return;
        }

        let filterItem = this.getActiveFilterById(id);
        if(typeof filterItem === 'undefined') {
            filterItem = new ActiveFilter(id, values);
            self.activeFilters.push(filterItem);
        } else {
            let key = this.getActiveFilterKeyById(id);
            self.activeFilters[key].setValues(values);
        }

    };

    self.getActiveFilters = () => {
        return self.activeFilters;
    };

    self.getActiveFilterById = (id) => {
        return self.activeFilters.find(function(activeFilter) {
            return (activeFilter.getId() === id);
        });
    };

    self.getActiveFilterKeyById = (id) => {

        for (let key in self.activeFilters) {
            if(this.activeFilters[key].getId() === id) {
                return key;
            }
        }
    };

    self.getQueryParams = () => {
        let queryParams = {};
        for(let activeFilter of self.activeFilters) {
            let selectedItems = activeFilter.getValues();
            let key = activeFilter.getId();
            if(selectedItems.length) {
                queryParams[key] = '';

                if(selectedItems.length === 1) {
                    queryParams[key] = selectedItems[0];
                } else {
                    for(let selectedItem of selectedItems ) {
                        if('' === queryParams[key]) {
                            queryParams[key] += selectedItem;
                        } else {
                            queryParams[key] += ',' + selectedItem;
                        }
                    }
                }
            }


        }
        return queryParams;
    };


    self.setInLocalStorage = () => {
        let sessionData = {};
        for(let activeFilter of self.activeFilters) {
            let selectedItems = activeFilter.getValues();
            let key = activeFilter.getId();

            if(selectedItems.length) {
                sessionData[key] = '';

                if(selectedItems.length === 1) {
                    sessionData[key] = selectedItems[0];
                } else {
                    for(let selectedItem of selectedItems ) {
                        if('' === sessionData[key]) {
                            sessionData[key] += selectedItem;
                        } else {
                            sessionData[key] += ',' + selectedItem;
                        }
                    }
                }
            }

            localStorage.setItem(key, sessionData[key]);
        }
    };




}



// WEBPACK FOOTER //
// ./resources/js/MrMovie/Filters/PageFilter.js